export default __webpack_public_path__ + "static/media/c19analyzer.5109e410.svg";